import * as React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Form,
  ConfigProvider,
  Row,
  Col,
  Space,
  Button,
  Grid,
  type FormProps,
  type FormInstance,
} from 'antd';

interface extraFormProps<Values = any> extends FormProps<Values> {
  showQueryBtn?: boolean,
  showResetBtn?: boolean
}
const searchFormColSpan:any = {
  xxl: 6,
  xl: 6,
  lg: 8,
  md: 12,
  sm: 12,
  xs: 24,
};
const InternalForm: React.ForwardRefRenderFunction<FormInstance, extraFormProps> = (props, ref) => {
  const intl = useIntl();
  const {
    prefixCls,
    className,
    children,
    showQueryBtn = true,
    showResetBtn = true,
    ...rest
  } = props;
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext);
  const formClassName = getPrefixCls('searchForm', prefixCls);
  const btns = [
    showQueryBtn == false
      ? null
      :<Button htmlType="button" key='searchFormBtn' onClick={() => {
        rest?.form?.resetFields?.();
        rest?.onFinish?.(true);
      }}>
        {intl.formatMessage({ defaultMessage: '重置' })}
      </Button>,
    showResetBtn == false
      ? null
      :<Button type="primary" key='resetFormBtn' htmlType="submit">
        {intl.formatMessage({ defaultMessage: '查询' })}
      </Button>
  ].filter(Boolean);
  const breakpoint = Grid.useBreakpoint();
  const screens = Object.entries(breakpoint).filter(screen => !!screen[1]).map(d => d[0]);
  const curScreens = screens.slice(-1)[0];
  const rowMaxItemsNum = 24 / searchFormColSpan[curScreens] ?? 1;//一行最多个数
  const rowNum = Math.ceil((React.Children.count(children)+1) / rowMaxItemsNum) ?? 1;//行数，含查询按钮
  const lastRowItemsNum = React.Children.count(children) % rowMaxItemsNum ?? 1;//最后一行个数，不含查询按钮
  let searchBtn = btns.length > 0
    ? (
      <Col style={{ alignSelf: 'flex-start', paddingTop: lastRowItemsNum === 0 ? '' : '30px' }}
        span={rowNum > 1 ? searchFormColSpan[curScreens] * (rowMaxItemsNum - lastRowItemsNum) : searchFormColSpan[curScreens]}>
        <Space size='small' className={rowNum > 1 ? 'float-right' : ''}>
          {btns}
        </Space>
      </Col>
    )
    : null;
  let newChildren = <Row gutter={[24, 12]}>
    {React.Children.map(children as React.ReactNode, (child,index) => <Col key={index} {...searchFormColSpan}>{child}</Col>)}
    {searchBtn}
  </Row>;
  return <Form
    key="searchForm"
    layout='vertical'
    className={classNames(className, formClassName)}
    prefixCls={prefixCls}
    children={newChildren}
    ref={ref}
    {...rest}
  />;
};

const SearchForm = React.forwardRef<FormInstance, extraFormProps>(InternalForm) as <Values = any>(
  props: React.PropsWithChildren<extraFormProps<Values>> & { ref?: React.Ref<FormInstance<Values>> },
) => React.ReactElement;

export default SearchForm;
